/**
 * @param {import("react-hook-form").ValidationRules} rules
 */
function make(rules) {
  return rules
}

export const MandatoryString = make({
  required: {
    value: true,
    message: 'required'
  },
  minLength: {
    value: 1,
    message: 'required'
  }
})

export const NonNegativeNumber = make({
  min: { value: 0, message: 'must be >=0' }
})

export const MandatoryNumberGreaterThanZero = make({
  required: { value: true, message: 'is required' },
  valueAsNumber: true,
  validate: {
    checkValue: value => value > 0 || 'Value must be greater than 0'
  }
})

const POSSIBLE_FORMATS = {
  clean: /\d{6}/,
  spaces: /\d{2} \d{2} \d{2}/,
  dots: /\d{2}\.\d{2}\.\d{2}/
}
const HAZARDOUS_INDICATOR = /\*{0,1}/
const EWC_REGEX = new RegExp(
  `^(${Object.values(POSSIBLE_FORMATS)
    .map(r => r.source + HAZARDOUS_INDICATOR.source)
    .join('|')})$`,
  'm'
)

export const isEmptyOrValidEWC = value => value === '' || EWC_REGEX.test(value)

export const ValidEWCCode = make({
  validate: {
    checkValue: value =>
      isEmptyOrValidEWC(value) ||
      'should be 6 digits, please update this to be able to save the record.'
  }
})
